import React from 'react'
import About from '../../components/About/About'
import Header from '../../components/Header/Header'
import Nav from '../../components/Nav/Nav'
import Filler from '../../components/Filler/Filler'
import Services from '../../components/Services/Services'
import Footer from '../../components/Footer/Footer'
import DropdownNav from '../../components/DropdownNav/DropdownNav'
import SEO from '../../components/SEO/SEO'

function Home() {
  return (
    <div>
      <SEO
        title="Symphony IT - Expert IT Services & Solutions in the DMV Area"
        description="Symphony IT provides managed IT services, cybersecurity, IT consulting, and technical support for businesses and homes in the DMV area. Orchestrate. Simplify. Secure."
        url="https://symphony-it.com/"
      />
      <Header />
      <Nav />
      <About />
      <Filler />
      <Services />
      <Footer/>

    </div>
  )
}

export default Home